import { apiPost, apiGet } from './api';

/**
 * Request a pre-signed upload URL from the backend.
 */
export async function getUploadUrl(fileName, contentType, fileSize, entityType, entityField) {
  return apiPost('/api/Files/upload-url', {
    fileName,
    contentType,
    fileSize,
    entityType,
    entityField,
  });
}

/**
 * Upload a file directly to the pre-signed URL (S3).
 */
export async function uploadToPresignedUrl(uploadUrl, file, contentType) {
  const response = await fetch(uploadUrl, {
    method: 'PUT',
    headers: { 'Content-Type': contentType },
    body: file,
  });
  return response.ok;
}

/**
 * Get a pre-signed download URL for a file attachment.
 */
export async function getDownloadUrl(fileAttachmentId) {
  return apiGet(`/api/Files/${fileAttachmentId}/download-url`);
}

/**
 * The upload rules for the caller's organisation: a size cap and accepted extensions per kind.
 * Served by the same resolver the upload validator uses, so the picker cannot drift from the API.
 */
export async function getUploadPolicy() {
  return apiGet('/api/Files/upload-policy');
}
